import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { StoreInformation } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/recommendation-management/main-page/$store-list')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="recommendationManagement.storeList.crumb" icon={StoreInformation} />,
      title: <Translation id="recommendationManagement.storeList.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
